import type { ReactNode } from "react";
import { BeforeYouReachOut } from "./before-you-reach-out";
import { ListingContactFacts } from "./listing-contact-facts";
import type { useListingContactHelp } from "./use-listing-contact-help";

export function ListingContactHelp({
    details,
    surface,
    children,
}: {
    details: ReturnType<typeof useListingContactHelp>;
    surface: "desktop" | "mobile";
    children: ReactNode;
}) {
    const { providerName, facts, experiment } = details;
    const { arm, onVisible } = experiment;
    if (arm === null) return children;
    const trackVisibility = (element: HTMLDivElement | null) => {
        if (!element) return;
        const observer = new IntersectionObserver((entries) => {
            if (
                !entries.some(
                    (entry) =>
                        entry.isIntersecting &&
                        entry.intersectionRect.width > 0 &&
                        entry.intersectionRect.height > 0,
                )
            )
                return;
            observer.disconnect();
            onVisible(surface);
        });
        observer.observe(element);
        return () => observer.disconnect();
    };
    return (
        <div ref={trackVisibility} data-listing-contact-help={arm}>
            {arm === "facts" ? (
                <ListingContactFacts
                    rows={facts.rows}
                    selected={facts.selected}
                    onToggle={(gap) => facts.toggleGap(gap, surface)}
                >
                    {children}
                </ListingContactFacts>
            ) : (
                <>
                    {children}
                    {arm === "reassurance" && (
                        <BeforeYouReachOut providerName={providerName} />
                    )}
                </>
            )}
        </div>
    );
}
